import { render, staticRenderFns } from "./ProductAccessories.vue?vue&type=template&id=743912b4"
import script from "./ProductAccessories.vue?vue&type=script&lang=js"
export * from "./ProductAccessories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductWideCard: require('/vercel/path0/components/shared/ProductWideCard.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
